import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { ProgressIndicator as ProgressIndicator$2, Step, ProgressLine, StepTopContainer, StepCircle, StyledIcon, StepChildren, DotsContainer, Dot } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import { UI_CHECKMARK } from '../../icons/UI_CHECKMARK.js';

var _excluded = ["steps", "activeStep", "additionalDoneSteps", "className", "showDotsLast"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ProgressIndicator = function ProgressIndicator(props) {
  var steps = props.steps,
    activeStep = props.activeStep,
    additionalDoneSteps = props.additionalDoneSteps,
    className = props.className,
    showDotsLast = props.showDotsLast,
    rest = _objectWithoutProperties(props, _excluded);
  var isGlobetrotter = useIsGlobetrotter();
  if (!steps || steps.length === 0) {
    return null;
  }
  var iconSize = isGlobetrotter ? 'xxs' : 'xs';
  return /*#__PURE__*/jsx(ProgressIndicator$2, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: steps.map(function (step, i) {
      var stepNumber = i + 1;
      var isLastStep = stepNumber === steps.length;
      var showLine = !isLastStep;
      var showDots = showDotsLast && isLastStep;
      var isActive = activeStep === stepNumber;
      var isAdditionalDoneStep = additionalDoneSteps.includes(stepNumber);
      var isBeforeActiveStep = activeStep > stepNumber;
      var isDone = isBeforeActiveStep || isAdditionalDoneStep;
      var type = 'future';
      if (isActive) {
        type = 'active';
      }
      if (isDone) {
        type = 'done';
      }
      return /*#__PURE__*/jsxs(Step, {
        children: [showLine && /*#__PURE__*/jsx(ProgressLine, {
          $shouldFill: isGlobetrotter ? false : isBeforeActiveStep,
          $numberOfSteps: steps.length
        }), /*#__PURE__*/jsx(StepTopContainer, {
          children: /*#__PURE__*/jsx(StepCircle, {
            $showDotsLast: showDotsLast,
            $isLastStep: isLastStep,
            $type: type,
            children: type === 'done' && /*#__PURE__*/jsx(StyledIcon, {
              path: UI_CHECKMARK,
              size: iconSize
            })
          })
        }), /*#__PURE__*/jsx(StepChildren, {
          $type: type,
          $isLastStep: isLastStep,
          children: step
        }), showDots && /*#__PURE__*/jsxs(DotsContainer, {
          children: [/*#__PURE__*/jsx(Dot, {}), /*#__PURE__*/jsx(Dot, {}), /*#__PURE__*/jsx(Dot, {})]
        })]
      }, "progressBarStep_".concat(stepNumber));
    })
  }));
};
ProgressIndicator.defaultProps = {
  className: undefined,
  showDotsLast: false,
  additionalDoneSteps: []
};
var ProgressIndicator$1 = ProgressIndicator;

export { ProgressIndicator$1 as default };
//# sourceMappingURL=ProgressIndicator.js.map
